import { http, createConfig } from 'wagmi';
import { mainnet, sepolia, polygon, arbitrum, optimism, base } from 'wagmi/chains';
import { injected, metaMask, walletConnect, coinbaseWallet } from 'wagmi/connectors';

// WalletConnect Project ID - Get your own at https://cloud.walletconnect.com
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'YOUR_PROJECT_ID';

export const config = createConfig({
    chains: [mainnet, sepolia, polygon, arbitrum, optimism, base],
    connectors: [
        injected(),
        metaMask(),
        coinbaseWallet({
            appName: 'Open Agar',
        }),
        walletConnect({ 
            projectId,
            showQrModal: true,
            metadata: {
                name: 'Open Agar',
                description: 'Agar.io Clone Game',
                url: window.location.origin,
                icons: ['https://avatars.githubusercontent.com/u/37784886']
            }
        }),
    ],
    transports: {
        [mainnet.id]: http(),
        [sepolia.id]: http(),
        [polygon.id]: http(),
        [arbitrum.id]: http(),
        [optimism.id]: http(),
        [base.id]: http(),
    },
});

